import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    admin: {
      dashboard: 'Dashboard',
      users: 'Users',
      payments: 'Payments',
      settings: 'Settings',
      logout: 'Logout'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
